module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('columns', [_c('column', {
    attrs: {
      "is-4": "",
      "is-offset-4": ""
    }
  }, [_c('field', {
    attrs: {
      "outerElement": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.login($event)
      }
    }
  }, [_c('label', [_vm._v("Username")]), _vm._v(" "), _c('control', {
    attrs: {
      "has-icons": "",
      "has-icons-left": "",
      "has-icons-right": "",
      "outerElement": "p"
    }
  }, [_c('b-input', {
    attrs: {
      "is-success": _vm.flag,
      "is-danger": !_vm.flag,
      "type": "text",
      "placeholder": "Text input",
      "value": "bulma"
    },
    on: {
      "input": _vm.toggle
    }
  }), _vm._v(" "), _c('icon', {
    attrs: {
      "outerElement": "span",
      "is-small": "",
      "is-left": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  })]), _vm._v(" "), (_vm.flag) ? _c('icon', {
    attrs: {
      "outerElement": "span",
      "is-small": "",
      "is-right": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  })]) : _vm._e()], 1), _vm._v(" "), _c('help', {
    attrs: {
      "is-success": ""
    }
  }, [_vm._v("This username is available")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "type": "submit",
      "is-primary": ""
    },
    on: {
      "click": _vm.greet
    }
  }, [_vm._v("Go")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ae6c14b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/example/form.vue
// module id = 16
// module chunks = 0